import { DEFAULT_BORDER } from 'constants/global';

import Finens from 'assets/icons/finens.svg';
import Reward from 'assets/icons/reward.svg';
import Person from 'assets/icons/person.svg';
import Adding from 'assets/icons/adding.svg';
import Atoms from 'assets/icons/atoms.svg';
import GraphDown from 'assets/icons/graph_down.svg';

const boxSize = {
  w: { mobile: '340px', laptop: '600px', desktop: '670px' },
  h: 'auto',
  minH: { mobile: '360px', xm: '340px', laptop: '440px', desktop: '600px' },
  p: {
    mobile: 'calc(40px + 12px + 8px) 24px 24px 24px',
    laptop: 'calc(72px + 12px + 12px) 48px 48px 48px',
  },
};
const iconProps = {
  boxSize: { mobile: '40px', laptop: '72px' },
  p: { mobile: '8px', laptop: '20px' },
};

export const itSupportExpertiseCardsSliderData = {
  textTitle: 'Почему это выгодно?',
  cardsData: [
    {
      src: Finens,
      title: 'Эффективность затрат',
      text: 'Помогаем экономить ресурсы, снижая затраты на персонал, но при этом гарантируем высокое качество поддержки и уровень экспертизы',
      iconProps,
      bgColor: 'bg.neonLight',
      ...boxSize,
    },
    {
      src: Reward,
      title: 'Экспертиза',
      text: 'Помогаем с MS Windows и пакетом MS365, Linux, macOS, Яндекс 360, офисным программным обеспечением, универсальными системами управления предприятием (ERP) и взаимоотношениями с заказчиками (CRM), кассовыми терминалами (POS), финансово‑техническими и медицинскими решениями.',
      iconProps: { bgColor: 'bg.gray', ...iconProps },
      bgColor: 'bg.white',
      border: DEFAULT_BORDER,
      borderColor: 'bg.gray',
      ...boxSize,
    },
    {
      src: Person,
      title: 'Низкая текучесть кадров',
      text: 'Предлагаем каждому сотруднику индивидуальный план развития, за счёт чего специалисты могут расти и развиваться, не меняя компанию',
      iconProps,
      bgColor: 'bg.grayLight',
      ...boxSize,
    },
    {
      src: Adding,
      title: 'Быстрое масштабирование',
      text: 'Имеем большую команду специалистов службы поддержки, а также продуманные процессы адаптации и обширную сеть, благодаря чему готовы оперативно отреагировать на любой ваш запрос',
      iconProps: { bgColor: 'bg.gray', ...iconProps },
      bgColor: 'bg.black',
      color: 'text.white',
      ...boxSize,
    },
    {
      src: Atoms,
      title: 'Процессы',
      text: 'Работаем в соответствии с лучшим отраслевым опытом, службы ИТ-помощи соответствуют требованиям мировых стандартов (ITIL)',
      iconProps,
      bgColor: 'bg.gray',
      ...boxSize,
    },
    {
      src: GraphDown,
      title: 'Снижение количества заявок',
      text: 'Внедряем интеллектуальные базы знаний, автоматизируем повторяющиеся проблемы, анализируем входящие обращения и предоставляем анализ коренных причин (RCA) происшествий',
      iconProps,
      bgColor: 'bg.accent',
      ...boxSize,
    },
  ],
};
